import React from "react";
import { Box, Typography } from "@mui/material";
import ColorField from "./ColorField";
import { pickTextColor } from "../themeEngine";

// A {fill, border} token editor. Text color is AUTO (spec §2) — shown as a
// read-only preview chip, never editable.
const ColorPairField = ({ label, value, onChange, testId }) => {
  const pair = value || {};
  const text = pair.fill ? pickTextColor(pair.fill) : "#111111";
  return (
    <Box data-testid={testId}>
      <Typography sx={{ fontSize: 13, color: "#565556", mb: 0.5, fontFamily: "DM Sans" }}>
        {label} — Fill
      </Typography>
      <ColorField value={pair.fill} onChange={(v) => onChange({ ...pair, fill: v })} />
      <Typography sx={{ fontSize: 13, color: "#565556", mt: 1, mb: 0.5, fontFamily: "DM Sans" }}>
        {label} — Border
      </Typography>
      <ColorField value={pair.border} onChange={(v) => onChange({ ...pair, border: v })} />
      {pair.fill && (
        <Box
          sx={{
            mt: 1,
            display: "inline-block",
            px: 1.5,
            py: 0.5,
            borderRadius: 1,
            backgroundColor: pair.fill,
            color: text,
            fontSize: 12,
            fontFamily: "DM Sans",
          }}
        >
          Auto text: {text}
        </Box>
      )}
    </Box>
  );
};

export default ColorPairField;
